var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0712 32.1278C9.0712 32.1278 16.3525 24.5862 15.723 15.9868C15.0935 7.3873 6.79149 0.98645 6.79149 0.98645C6.79149 0.98645 -0.48986 8.52808 0.139662 17.1275C0.769185 25.727 9.0712 32.1278 9.0712 32.1278Z",
    fill: "#7675FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96908 32.3486C8.96908 32.3486 18.4287 31.3444 23.0943 24.9753C27.76 18.6062 25.8649 9.28411 25.8649 9.28411C25.8649 9.28411 16.4053 10.2883 11.7396 16.6574C7.07397 23.0265 8.96908 32.3486 8.96908 32.3486Z",
    fill: "#F26C74"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53696 32.477C9.53696 32.477 17.4608 36.0352 24.9543 33.5491C32.4478 31.063 36.6734 23.474 36.6734 23.474C36.6734 23.474 28.7495 19.9158 21.256 22.4019C13.7625 24.888 9.53696 32.477 9.53696 32.477Z",
    fill: "#FAA881"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.eaff9030d23724006423fe50ea6d5967.svg";
export { ForwardRef as ReactComponent };